import { theme, toggleTheme } from "../../app/theme";
import { Icon } from "./Icon";

export function ThemeToggle() {
  return (
    <button
      class="btn btn-ghost icon-btn"
      onClick={toggleTheme}
      title={theme() === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      aria-label="Toggle colour theme"
    >
      <Icon name={theme() === "dark" ? "sun" : "moon"} />
    </button>
  );
}
